import { Bridge } from '../../types/services/enums';
export const deepConvertBigInt = (obj) => {
    if (obj === null || typeof obj !== 'object')
        return obj;
    for (const key in obj) {
        const value = obj[key];
        if (typeof value === 'bigint') {
            obj[key] = value.toString();
        }
        else if (typeof value === 'object') {
            deepConvertBigInt(value);
        }
    }
    return obj;
};
export const deepConvertWormhole = (obj) => {
    try {
        const converted = Array.isArray(obj)
            ? obj.map((item) => convertObject(Object.assign(Object.assign({}, item), { bridge: item.bridge || Bridge.WORMHOLE })))
            : convertObject(Object.assign(Object.assign({}, obj), { bridge: obj.bridge || Bridge.WORMHOLE }));
        return converted;
    }
    catch (e) {
        console.error('Conversion error:', e);
        throw e;
    }
};
// Keep your existing convertObject function unchanged
const convertObject = (obj) => {
    if (!obj)
        return null;
    if (typeof obj !== 'object')
        return obj;
    const clone = {};
    // Handle all properties including transactions
    for (let [key, value] of Object.entries(obj)) {
        const typeStrongValue = value;
        if (key === 'wormholeTokenTransfer' && (typeStrongValue === null || typeStrongValue === void 0 ? void 0 : typeStrongValue.transfer)) {
            clone[key] = {
                transfer: {
                    token: String(typeStrongValue.transfer.token),
                    amount: String(typeStrongValue.transfer.amount),
                    from: String(typeStrongValue.transfer.from),
                    to: String(typeStrongValue.transfer.to),
                    automatic: Boolean(typeStrongValue.transfer.automatic),
                    payload: typeStrongValue.transfer.payload || null,
                    nativeGas: String(typeStrongValue.transfer.nativeGas),
                },
                fromChain: { chain: String(typeStrongValue.fromChain.chain) },
                toChain: { chain: String(typeStrongValue.toChain.chain) },
            };
        }
        else {
            clone[key] =
                typeof typeStrongValue === 'bigint'
                    ? typeStrongValue.toString()
                    : typeStrongValue === null
                        ? null
                        : typeof typeStrongValue === 'object'
                            ? convertObject(typeStrongValue)
                            : typeStrongValue;
        }
    }
    return clone;
};
